export enum EUserRole {
  OWNER = 'owner', // Perfil para desarrollo
  SUPER_ADMIN = 'super_admin', // Perfil del administrador del negocio
  SUPER_ADMIN_AUDITOR = 'super_admin_auditor', // Perfil del auditor global (solo lectura)
  API_ADMIN = 'api_admin', // Perfil del administrador de la API
  API_SUPER_ADMIN = 'api_super_admin', // Perfil del super administrador de la API
  API_ATENTY_ADMIN = 'api_atenty_admin', // Perfil del administrador de la API de WhatsApp (Atenty)
  API_ROBLELABS_ADMIN = 'api_roblelabs_admin', // Perfil del administrador de la API de Roble (RobleLabs / Dactilar)
  ADMIN_ORGANIZATION = 'admin_organization', // Perfil del administrador de la organización
  USER_ORGANIZATION = 'user_organization', // Perfil del usuario de la organización
  AUDITOR_ORGANIZATION = 'auditor_organization', // Perfil del auditor de la organización
  EXECUTIVE_ORGANIZATION = 'executive_organization', // Perfil del ejecutivo de la organización
  CLIENT = 'client', // Perfil del cliente por defecto
}
